const messages = {
  _default: (field: string) => `Заполните поле ${field}`,
};

export default {
  name: 'ru',
  messages,
};
